var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{staticClass:"looker",staticStyle:{"border":"0","display":"block","margin":"0 auto"},attrs:{"width":"90%","height":"auto","src":"https://lookerstudio.google.com/embed/reporting/2e9769ed-2545-47c6-997e-56c2a51fd8c0/page/fPNFD","frameborder":"1","allowfullscreen":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }